import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  PublicNewsDetail,
  PublicNewsListItem,
  PublicNewsTableResponse,
} from '../../../models/news.model';

@Injectable({
  providedIn: 'root',
})
export class ApiNewsService {
  private privateApiUrl = `${environment.apiPrivateUrl}`;

  constructor(private http: HttpClient) {}

  /*############################################# API #################################################*/

  /**
   * ข่าว Home (limit 5)
   * GET /CityParking/getPublicNewsForHome?siteId=&limit=5
   */
  getPublicNewsForHome(siteId?: number | null, limit = 5): Observable<PublicNewsListItem[]> {
    let params = new HttpParams().set('limit', String(limit));
    if (siteId != null && siteId > 0) {
      params = params.set('siteId', String(siteId));
    }
    return this.http.get<PublicNewsListItem[]>(
      `${this.privateApiUrl}/CityParking/getPublicNewsForHome`,
      { params },
    );
  }

  /**
   * รายการข่าวทั้งหมด (paging)
   * GET /CityParking/getPublicNews?siteId=&categoryId=&page=&pageSize=
   */
  getPublicNews(
    siteId?: number | null,
    categoryId?: number | null,
    page = 1,
    pageSize = 20,
  ): Observable<PublicNewsTableResponse> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('pageSize', String(pageSize));
    if (siteId != null && siteId > 0) {
      params = params.set('siteId', String(siteId));
    }
    if (categoryId != null && categoryId > 0) {
      params = params.set('categoryId', String(categoryId));
    }
    return this.http.get<PublicNewsTableResponse>(
      `${this.privateApiUrl}/CityParking/getPublicNews`,
      { params },
    );
  }

  /**
   * รายละเอียดข่าว + gallery
   * GET /CityParking/getPublicNewsById?id=&siteId=
   */
  getPublicNewsById(id: number, siteId?: number | null): Observable<PublicNewsDetail> {
    let params = new HttpParams().set('id', String(id));
    if (siteId != null && siteId > 0) {
      params = params.set('siteId', String(siteId));
    }
    return this.http.get<PublicNewsDetail>(
      `${this.privateApiUrl}/CityParking/getPublicNewsById`,
      { params },
    );
  }

  /**
   * ประกาศจากลาน — เฉพาะข่าวของลานนั้น (ไม่รวม City Parking)
   * GET /CityParking/getPublicSiteNews?ref=&page=&pageSize=
   */
  getPublicSiteNews(publicRef: string, page = 1, pageSize = 5): Observable<PublicNewsTableResponse> {
    const params = new HttpParams()
      .set('ref', publicRef)
      .set('page', String(page))
      .set('pageSize', String(pageSize));
    return this.http.get<PublicNewsTableResponse>(
      `${this.privateApiUrl}/CityParking/getPublicSiteNews`,
      { params },
    );
  }
}
